import { AppThunk } from '../../../../storage/store';
import { fetchStart, fetchSuccess, fetchFailed } from './slice';
import { fetchVendorChargerStatusAPI } from './api';
import { getToken } from '../../../../utils/auth';

export const getVendorChargerStatus = (stationId?: number): AppThunk => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const data = await fetchVendorChargerStatusAPI(token, stationId);
    dispatch(fetchSuccess(data));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load charger status.'));
  }
};
